import React, {useMemo } from "react";
import RightQueryBar from "../Querbuilder/rightBar";
import { generateSQLQuery } from "../../utilities/Constants/Constants";

const QueryPreviewBar = ({
  index,
  table,
  tableQueryDataMap,
}: {
  index: number;
  table: string;
  tableQueryDataMap: any;
}) => {
  const query = useMemo(
    () => {
      const tableItem = tableQueryDataMap[table]
      return {
        tablename: table,
        query: generateSQLQuery(table, tableItem),
      }
    },
    [table, tableQueryDataMap]
  );

  return (
    <RightQueryBar
      query={query}
      initialPosition={{ x: 20, y: 50 + index * 50 }}
    />
  );
};

export default QueryPreviewBar;
